import React from 'react';
import { motion } from 'framer-motion';
export function Booking() {
  return <div className="min-h-screen bg-dark pt-32 pb-24 px-6 md:px-12" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-77">
          <h1 className="text-4xl md:text-5xl font-cinzel text-gold mb-4" data-id="element-78">
            Book Your Session
          </h1>
          <div className="h-[1px] w-24 bg-gold/30 mx-auto" data-id="element-79" />
        </motion.div>

        {/* Calendly Embed Placeholder */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full" data-id="element-80">
          <div className="w-full border border-white/10 rounded-lg overflow-hidden bg-white/[0.02]" data-id="element-81">
            <iframe src="https://calendly.com/juliettecazabat-nz/online-individual-session" title="Book a session with Juliette Cazabat" className="w-full bg-transparent" style={{
            height: '700px',
            border: 'none'
          }} data-id="element-82" />
            {/* Placeholder overlay — remove when real Calendly URL is added */}
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" style={{
            position: 'relative',
            marginTop: '-700px',
            height: '700px'
          }} data-id="element-83">
              <p className="text-cream/40 font-inter text-sm uppercase tracking-widest mb-2" data-id="element-84">
                Calendly Widget
              </p>
              <p className="text-cream/25 font-inter text-xs max-w-xs text-center" data-id="element-85">
                Replace the iframe src with your Calendly scheduling link
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}